import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

interface Props {
  fieldId: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  opened: boolean;
  label: React.ReactNode;
  children: React.ReactChild;
}

export function CheckboxWithSubFields({
  fieldId,
  checked,
  onChange,
  label,
  opened,
  children,
}: Props): JSX.Element {
  return (
    <div className="form-row">
      <div className="form-group col-12">
        <div className="form-check">
          <input
            type="checkbox"
            className="form-check-input"
            id={fieldId}
            onChange={(e) => onChange(e.target.checked)}
            checked={checked}
          />
          <label className="form-check-label" htmlFor={fieldId}>
            {label}
          </label>
        </div>
        {opened ? <SubFields>{children}</SubFields> : null}
      </div>
    </div>
  );
}

const SubFields = styled.div`
  border-left: 3px solid ${colors.borderGray};
  margin-left: 5px;
  padding: 0.5rem;
  margin-top: 0.25rem;
`;
